// pages/FormViewerPage/services/formViewerService/pixelsThankYouPage.ts — Thank-you page pixel configs
import type { Form } from '../../../../types';
import type { PlatformPixelConfig } from '../../types';
import { withOptimizationPixels } from './pixelOptimization';

export function getThankYouPagePixelConfigs(
    form: Form | null,
    globalTrackingSettings: any,
    settingsLoading: boolean,
    activePlatform: string | null
): { allConfigs: PlatformPixelConfig[]; metaConfig: { ids: string[]; eventName: string } } {
    if (!form) return { allConfigs: [], metaConfig: { ids: [], eventName: 'Lead' } };
    const allConfigs: PlatformPixelConfig[] = [];
    const trackingSettings = form.trackingSettings?.thankYouPage;
    const formPageTracking = form.trackingSettings?.formPage;

    // Meta
    // Thanks page form fisik = Lead (order baru Pending, closing nanti via CAPI sweep).
    {
        let metaIds: string[] = [];
        let metaEvent = 'Lead';
        if (trackingSettings?.meta?.pixelIds && trackingSettings.meta.pixelIds.length > 0) {
            metaIds = trackingSettings.meta.pixelIds.filter((id: string) => id?.trim());
            // WYSIWYG: thanks page belum tentu Purchase (baru Lead) — fire sesuai dropdown.
            metaEvent = trackingSettings.meta.eventName || 'Lead';
        } else if (formPageTracking?.meta?.pixelIds && formPageTracking.meta.pixelIds.length > 0) {
            metaIds = formPageTracking.meta.pixelIds.filter((id: string) => id?.trim());
        }
        // Pixel optimasi iklan brand form ini ikut menerima Lead (browser + CAPI).
        metaIds = withOptimizationPixels(metaIds, globalTrackingSettings?.meta?.pixels, (form as any)?.brandId);
        if (metaIds.length > 0) allConfigs.push({ platform: 'meta', pixelIds: metaIds, eventName: metaEvent });
    }

    // Google — thanks = Lead (Pending). Purchase hanya via CAPI sweep.
    {
        let googleIds: string[] = [];
        let googleEvent = 'Lead';
        if (trackingSettings?.google?.pixelIds && trackingSettings.google.pixelIds.length > 0) {
            googleIds = trackingSettings.google.pixelIds.filter((id: string) => id?.trim());
            googleEvent = trackingSettings.google.eventName || 'Lead';
        } else if (formPageTracking?.google?.pixelIds && formPageTracking.google.pixelIds.length > 0) {
            googleIds = formPageTracking.google.pixelIds.filter((id: string) => id?.trim());
        }
        // Pixel optimasi iklan (Google Ads) brand form ini ikut menerima Lead.
        googleIds = withOptimizationPixels(googleIds, globalTrackingSettings?.google?.pixels, (form as any)?.brandId);
        if (googleIds.length > 0) allConfigs.push({ platform: 'google', pixelIds: googleIds, eventName: googleEvent });
    }

    // TikTok — thanks = Lead (SubmitForm). CompletePayment hanya via CAPI sweep.
    {
        let tiktokIds: string[] = [];
        let tiktokEvent = 'Lead';
        if (trackingSettings?.tiktok?.pixelIds && trackingSettings.tiktok.pixelIds.length > 0) {
            tiktokIds = trackingSettings.tiktok.pixelIds.filter((id: string) => id?.trim());
            tiktokEvent = trackingSettings.tiktok.eventName || 'Lead';
        } else if (formPageTracking?.tiktok?.pixelIds && formPageTracking.tiktok.pixelIds.length > 0) {
            tiktokIds = formPageTracking.tiktok.pixelIds.filter((id: string) => id?.trim());
        }
        // Pixel optimasi iklan brand form ini ikut menerima Lead TikTok.
        tiktokIds = withOptimizationPixels(tiktokIds, globalTrackingSettings?.tiktok?.pixels, (form as any)?.brandId);
        if (tiktokIds.length > 0) allConfigs.push({ platform: 'tiktok', pixelIds: tiktokIds, eventName: tiktokEvent });
    }

    // Snack — thanks = Lead. PURCHASE hanya via CAPI sweep.
    {
        let snackIds: string[] = [];
        let snackEvent = 'Lead';
        if (trackingSettings?.snack?.pixelIds && trackingSettings.snack.pixelIds.length > 0) {
            snackIds = trackingSettings.snack.pixelIds.filter((id: string) => id?.trim());
            snackEvent = trackingSettings.snack.eventName || 'Lead';
        } else if (formPageTracking?.snack?.pixelIds && formPageTracking.snack.pixelIds.length > 0) {
            snackIds = formPageTracking.snack.pixelIds.filter((id: string) => id?.trim());
        }
        // Pixel optimasi iklan brand form ini ikut menerima Lead Snack.
        snackIds = withOptimizationPixels(snackIds, globalTrackingSettings?.snack?.pixels, (form as any)?.brandId);
        if (snackIds.length > 0) allConfigs.push({ platform: 'snack', pixelIds: snackIds, eventName: snackEvent });
    }

    // OpenAI Ads — thanks = Lead; closing order_created dikirim sweep.
    {
        let ids = trackingSettings?.openai?.pixelIds?.filter((id: string) => id?.trim()) || [];
        const eventName = trackingSettings?.openai?.eventName || 'Lead';
        if (!ids.length) ids = formPageTracking?.openai?.pixelIds?.filter((id: string) => id?.trim()) || [];
        ids = withOptimizationPixels(ids, globalTrackingSettings?.openai?.pixels, (form as any)?.brandId);
        if (ids.length) allConfigs.push({ platform: 'openai', pixelIds: ids, eventName });
    }

    const metaConfig = allConfigs.find(c => c.platform === 'meta');
    return { allConfigs, metaConfig: { ids: metaConfig?.pixelIds || [], eventName: metaConfig?.eventName || 'Lead' } };
}
